import ReservationExternalStep1 from "@/modules/front/ReservationExternal/ReservationExternalStep1";
import React from "react";
import ReservationExternalStep2 from "@/modules/front/ReservationExternal/ReservationExternalStep2";
import FormProgress from "@/modules/front/ReservationExternal/FormProgress";
import moment from "moment/moment";
import OrderService from "@/modules/front/services/OrderService";
import ReservationExternalStepFinish from "@/modules/front/ReservationExternal/ReservationExternalStepFinish";
import ReservationExternalStepExtras from "@/modules/front/ReservationExternal/ReservationExternalStepExtras";
const ReservationExternal = (props) => {
    const [step, setStep] = React.useState(1);
    const [error, setError] = React.useState(null);

    const [dateFrom, setDateFrom] = React.useState(null);
    const [dateTo, setDateTo] = React.useState(null);
    const [totalPrice, setTotalPrice] = React.useState(null);
    const [itemPrice, setItemPrice] = React.useState(null);

    const pricingNote = ''; // *Všechny ceny jsou uvedeny bez DPH.

    const [personalData, setPersonalData] = React.useState({});
    const [selectedServices, setSelectedServices] = React.useState([
        // {
        //     name: "Servisní poplatek",
        //     price: 1500,
        //     quantity: 1
        // }
    ]);

    const [selectedItems, setSelectedItems] = React.useState([]);

    const [submitting, setSubmitting] = React.useState(false);

    const handleSelectedServices = (serviceIds, services, itemIds, items) => {
        // Remove all from selectedServices with id
        let newSelectedServices = selectedServices.filter((selectedService) => {
            return selectedService.id === undefined;
        });

        // Add all services with id in serviceIds by data from services
        services.forEach((service) => {
            if (serviceIds.includes(service.id)) {
                newSelectedServices.push({
                    id: service.id,
                    name: service.name,
                    price: service.price,
                    quantity: 1
                });
            }
        });

        setSelectedServices(newSelectedServices);

        let newSelectedItems = [];
        items.forEach((item) => {
            if (itemIds.includes(item.id)) {
                newSelectedItems.push(item);
            }
        });
        setSelectedItems(newSelectedItems);

        OrderService.createOrder(
            personalData.firstname,
            personalData.lastname,
            personalData.email,
            personalData.phone,
            dateFrom,
            dateTo,
            [window.variables.entityId, ...itemIds],
            newSelectedServices,
            false,
            personalData.address,
            personalData.city,
            personalData.zip,
            personalData.company_name,
            personalData.company_id,
            personalData.company_vat_id
        ).then((response) => {
            if (response.error) {
                setError(response.error)
            }
            else {
                setTotalPrice(response.totalPrice);
                setItemPrice(response.itemPrice);
                setError(false);
            }
        });
    }

    const handleDateConfirmed = (dateFrom, dateTo, officeId) => {
        setDateFrom(dateFrom);
        setDateTo(dateTo);
        setError(null);
    }

    const handlePersonalData = (data) => {
        setPersonalData(data);
        OrderService.createOrder(
            data.firstname,
            data.lastname,
            data.email,
            data.phone,
            dateFrom,
            dateTo,
        [window.variables.entityId],
            selectedServices,
            false,
            data.address,
            data.city,
            data.zip,
            personalData.company_name,
            personalData.company_id,
            personalData.company_vat_id
            ).then((response) => {
                if (response.error) {
                    setError(response.error)
                }
                else {
                    setStep(2);
                    setTotalPrice(response.totalPrice);
                    setItemPrice(response.itemPrice);
                    setError(null);
                }
            });

    }

    const handleSubmit = () => {
        setSubmitting(true);
        OrderService.createOrder(
            personalData.firstname,
            personalData.lastname,
            personalData.email,
            personalData.phone,
            dateFrom,
            dateTo,
            [window.variables.entityId, ...selectedItems.map((item) => item.id)],
            selectedServices,
            true,
            personalData.address,
            personalData.city,
            personalData.zip,
            personalData.company_name,
            personalData.company_id,
            personalData.company_vat_id
        ).then((response) => {
            setSubmitting(false);
            if (response.error) {
                setError(response.error)
            }
            else {
                if (response.orderId) {
                    setStep(99);
                }
                else {
                    setError("Něco se pokazilo, zkuste to prosím znovu.")
                }
            }
        });
    }

    let stepContent = null;
    switch (step) {
        case 1:
            stepContent = <ReservationExternalStep1 setStep={setStep}
                                                    onPersonalDataSubmitted={handlePersonalData}
                                                    onDateConfirmed={handleDateConfirmed}
                                                    onError={setError}
                                                    dateFrom={dateFrom}
                                                    dateTo={dateTo}
                                                    personalData={personalData}
                                                    pricingNote={pricingNote}
                                                    {...props}/>;
            break;
        case 2:
            stepContent = <ReservationExternalStepExtras setStep={setStep}
                                                         setSelectedServices={handleSelectedServices}
                                                         dateFrom={dateFrom}
                                                         dateTo={dateTo}
                                                         itemId={window.variables.entityId}
                                                         pricingNote={pricingNote}

                                                         {...props}/>;
            break;
        case 3:
            stepContent = <ReservationExternalStep2 setStep={setStep}
                                                    personalData={personalData}
                                                    dateFrom={dateFrom}
                                                    dateTo={dateTo}
                                                    totalPrice={totalPrice}
                                                    itemTitle={props.itemTitle}
                                                    itemPrice={itemPrice}
                                                    onSubmit={handleSubmit}
                                                    onDateConfirmed={handleDateConfirmed}
                                                    selectedServices={selectedServices}
                                                    selectedItems={selectedItems}
                                                    onErrors={setError}
                                                    submitting={submitting}
                                                    pricingNote={pricingNote}
                                                    {...props}/>;
            break;
        case 99:
            stepContent = <ReservationExternalStepFinish />

            break;
    }

    let errorBox = null;
    if (error) {
        errorBox = <div className="alert alert-danger" role="alert">
            {error}
        </div>;
    }

    return <div>
        {errorBox}
        {/*<FormProgress steps={[window.translations.reservationExternal.steps.selectDate, window.translations.reservationExternal.steps.enterDetails]} currentStep={step - 1}/>*/}
        {stepContent}

    </div>

};

export default ReservationExternal;